export default "__VITE_ASSET__BhSRU1Js__"